<template>
    <div>
        <table class="authorization-table" :class="[themeColor,tableData.length > 3 ? 'many' : 'few']" border="0" cellspacing='0' cellpadding='0'>
            <colgroup>
                <col width='53px'>
                <col width='auto'>
                <col width='80px'>
                <col width='120px'>
                <!-- <col v-if='!isInternal' width='87px'> -->
            </colgroup>
            
            <template v-if='isInternal'>
                <thead>
                    <tr>
                        <th rowspan="1">勾选</th>
                        <th rowspan="1">{{isHistory ? '服务名称': '授权名称'}}</th>
                        <!-- <th colspan="2" rowspan="1">
                            <h5>价格(单位：元/账号/年)</h5>
                        </th> -->
                        <th rowspan="1" colspan="1">价格</th>
                        <th rowspan="1">备注</th>
                    </tr>
                    <!-- <tr>
                        <th class="no_padding" rowspan="1" colspan="1">购买人</th>
                        <th class="no_padding" rowspan="1" colspan="1">价格</th>
                    </tr> -->
                </thead>
                <tbody>
                    <tr class="internal_tr" v-for="(item,index) in [...internalData, ...currentData]" :key='item._id' :class="{disabled: isDisable(item) || item.isChecked}"  @click="choose(item,index)">
                        <td>
                            <div class="select" :class="{active: item.cselect || item.isChecked,disabled: isDisable(item) || item.isChecked}"></div>
                        </td>
                        <td class="data_box" :class="{disabled: isDisable(item) || item.isChecked}">
                            {{item.productName}}
                            <i class='tips' v-if='item.productName.indexOf("金融期货交易所（CFFEX）境外查看") >= 0'>
                                <div class="tips_content">如需在境外查看中金一档数据，需付数据使用费</div>
                            </i>
                        </td>
                        <td style='border-bottom:1px solid #ebf1f5;'>
                            <span class="price"
                                :class="{major_active:item.cmajor == 0 || item.cmajor == null}">{{price(item)}}</span>
                                
                        </td>
                        <td class="pop" :class="{last: index >= [...internalData, ...currentData].length - 2}" style='border-bottom:1px solid #ebf1f5;' @click.stop="_=>{}">
                            <span v-content:[13]="item.productintro">{{isHistory ? '品种': '交易品种'}}</span>
                        </td>
                    </tr>
                </tbody>
            </template>
            <template v-else>
                <thead>
                    <tr>
                        <th rowspan="1">勾选</th>
                        <th rowspan="1">授权交易所</th>
                        <!-- <th rowspan="1">{{isHistory ? '服务名称': '授权名称'}}</th> -->
                        <!-- <th colspan="2" rowspan="1">
                            <h5>价格(单位：元/账号/年)</h5>
                        </th> -->
                        <th rowspan="1" colspan="1">购买人身份</th>
                        <th rowspan="1" colspan="1">价格(元/账号{{oldright().data != '' ? '' : '/' + (price_mode == 'quater' ? '季' : "年")}})</th>
                        <!-- <th rowspan="1">备注</th> -->
                    </tr>
                    <!-- <tr>
                        <th class="no_padding" rowspan="1" colspan="1">购买人</th>
                        <th class="no_padding" rowspan="1" colspan="1">价格</th>
                    </tr> -->
                </thead>
                <tbody>
                    <tr v-for="(item,index) in [...CMEData, ...EUREXData, ...ICEData, ...otherOuterData, ...HKData]" :key='item._id' :class="{disabled: isDisable(item) || item.isChecked}"  @click="choose(item,index)">
                        <td>
                            <div class="select" :class="{active: item.cselect || item.isChecked,disabled: isDisable(item) || item.isChecked}"></div>
                        </td>
                        <td class="data_box" :class="{disabled: isDisable(item) || item.isChecked}">
                            <span style="color: #919095;">{{item.productName}}</span>
                            <div v-if="item.productName != '美国股票' && item.productName != '香港交易所股票（全球查看）' && item.productName != '香港交易所股票（仅中国大陆内查看）'">
                                {{productintro_deal(item.productintro)}}
                                <span v-content:[13]="productintro_deal_In(item.productintro)" style="color: #4a8bd2;">更多...</span>
                            </div>
                        </td>
                        <template v-if="item.price != item.majorprice">
                            <!-- <td colspan="1" style='border-bottom:1px solid #ebf1f5;'>
                                <span class="price"
                                    :class="{major_active:item.cmajor == 0 || item.cmajor == null}">{{parseInt(item.price)}}</span>
                                    
                            </td>
                            <td style='border-bottom:1px solid #ebf1f5;'>
                                <span class="price"
                                        :class="{major_active:item.cmajor == 1 || item.cmajor == null}">{{parseInt(item.majorprice)}}</span>
                            </td> -->
                            <td colspan="1" style='border-bottom:1px solid #ebf1f5;' class="purchaser">
                                <span class="people" :class="{major_active:item.cmajor == 0 || item.cmajor == null}">{{isEurexOrHK(item) ? "个人":"非专业用户"}}</span>
                                <span class="people" :class="{major_active:item.cmajor == 1 || item.cmajor == null}">{{isEurexOrHK(item) ? "公司":"专业用户"}}</span>
                            </td>
                            <td style='border-bottom:1px solid #ebf1f5;' class="charge">
                                <!-- <span class="price" :class="{major_active:item.cmajor == 0 || item.cmajor == null}">
                                    {{parseInt(item.price)}}
                                    <i class='tips' v-if='item.productName.indexOf("欧洲期货交易所（EUREX)") >= 0'>
                                        <div class="tips_content">欧交所个人价格只针对中国境内用户有效</div>
                                    </i>    
                                </span>
                                
                                <span class="price" :class="{major_active:item.cmajor == 1 || item.cmajor == null}">{{parseInt(item.majorprice)}}</span> -->
                                <span class="price" style="color: #78363a;">
                                    {{price(item)}}
                                    <i class='tips' v-if='item.productName.indexOf("欧洲期货交易所（EUREX)") >= 0'>
                                        <div class="tips_content EUREX">欧交所个人价格只针对中国境内用户有效</div>
                                    </i>    
                                </span>
                                
                                <span class="price" style="color: #78363a;">{{majorPrice(item)}}</span>
                            </td>
                        </template>
                        <template v-else>
                            <td style="border-bottom:1px solid #ebf1f5;" class="purchaser">
                                <span class="people"
                                    :class="{major_active:item.cmajor == 0 || item.cmajor == null}">{{isEurex(item) ? '个人': '/'}}</span>
                                    
                            </td>
                            <td style='border-bottom:1px solid #ebf1f5;' class="charge">
                                <!-- <span class="price"
                                    :class="{major_active:item.cmajor == 0 || item.cmajor == null}">{{item.price}}</span> -->
                                <span class="price" style="color: #78363a;">{{price(item)}}<i class='tips' v-if='item.productname_short.indexOf("欧洲期货交易所（EUREX)") >= 0'>
                                        <div class="tips_content EUREX">欧交所个人价格只针对中国境内用户有效</div>
                                    </i> </span>
                            </td>
                        </template>
                        <!-- <td class="pop" :class="{last: index >= [...CMEData, ...EUREXData, ...ICEData, ...otherOuterData, ...HKData].length - 2}" style='border-bottom:1px solid #ebf1f5;' @click.stop="_=>{}">
                            <span v-content:[13]="item.productintro">{{isHistory ? '品种': '交易品种'}}</span>
                        </td> -->
                    </tr>
                </tbody>
            </template>
            
        </table>
    </div>
</template>

<script>
    // @ is an alias to /src
    import wh from '@/assets/js/wh.js'
    export default {
        name: 'authtable',
        model: {
            prop: 'authPrice',
            event: 'change'
        },
        inject: ['globalTabType','fatherType', 'oldright'],
        props: {
            authData: {
                type: Array,
                default: () => ([])
            },
            authPrice: {
                type: Number,
                default: 0
            },
            themeColor: {
                type: String,
                default: ''
            },
            itemname: {
                type: String,
                default: ''
            },
            isHistory: {
                type: Boolean,
                default: false
            }
        },
        data: () => ({
            tableData: [],
            internalData: [],
            currentData: [],
            CMEData: [],
            EUREXData: [],
            ICEData: [],
            HKData: [],
            otherOuterData: [],
            price_mode: ''
        }),
        methods: {
            productintro_deal(item){
                let arr = item.replace("所包含品种：", "").split("、").filter((item, index) => {
                    return index < 3
                })
                let str = arr.join("、")
                
                return str
            },
            productintro_deal_In(item){
                let arr = item.replace("所包含品种：", "").split("、").filter((item, index) => {
                    return index >= 3
                })
                let str = arr.join("、")
                
                return str
            },
            async click(item, index, call) {
                if (item.isChecked) return //已默认勾选不操作
                if(item.cdisable) return //已禁用的不做任何操作
                if(item.creject) return //已禁用的不做任何操作
                this.selectItem(item, resolve => {
                    this.$market.purchaserSelect({
                        list: [{
                                text: item.productlink.indexOf('EUREX') < 0 && item.productName.indexOf('香港') < 0 ? '本人确认，本人符合非专业用户资格' : '本人特此确认，本人是个人用户'
                            },
                            {
                                text: item.productlink.indexOf('EUREX') < 0 && item.productName.indexOf('香港') < 0? '本人确认，本人符合专业用户资格' : '本人特此确认，本人是公司用户'
                            }
                        ],
                        confirmCall(val) {
                            resolve(val)
                        },
                        noAgreement: item.productlink.indexOf('EUREX') < 0 && item.productName.indexOf('香港') < 0 ? false : true,
                        content: item.productlink.indexOf('EUREX') < 0 && item.productName.indexOf('香港') < 0 ? '请确认本人身份 <br>（针对专业用户和非专业用户数据授权费不同）' : '请确认本人身份 <br>（针对公司用户和个人用户数据授权费不同）'
                    })
                },call)
                
            },
            async selectItem (item, majorChooseHandler, call) { //majorChooseHandler（可选），选则专业身份的弹窗Promise，必须是Promise
                if (item.cselect == false) {
                    if (item.price != item.majorprice && item.cmajor == null) {
                        if (majorChooseHandler) {
                            var option = await new Promise(majorChooseHandler)
                            item.cmajor = option
                        }
                        if (item.productlink.indexOf('EUREX') < 0 && item.productName.indexOf('香港') < 0) {
                            this.tableData.forEach(v=>{
                                if ((v.productlink.indexOf('EUREX') < 0 && v.price != v.majorprice) && (v.productName.indexOf('香港') < 0 && v.price != v.majorprice)) {
                                    v.cmajor = option
                                }
                            })
                        } else if (item.productlink.indexOf('EUREX') >= 0 || item.productName.indexOf('香港') >= 0) {
                            this.tableData.forEach(v=>{
                                if ((v.productlink.indexOf('EUREX') >= 0 || v.productName.indexOf('香港') >= 0 ) && v.price != v.majorprice) {
                                    v.cmajor = option
                                }
                            })
                        }
                    } 
                    item.cselect = true
                    
                    
                } else {
                    item.cselect = false
                    var unEUREX = this.tableData.filter(v=>v.productlink.indexOf('EUREX') < 0 && v.productName.indexOf('香港') < 0 && v.price != v.majorprice)
                    var EUREXOrHK = this.tableData.filter(v=>(v.productlink.indexOf('EUREX') >= 0 || v.productName.indexOf('香港') >= 0) && v.price != v.majorprice)
                    if (item.productlink.indexOf('EUREX') < 0 && item.productName.indexOf('香港') < 0 && !unEUREX.some(v=>v.cselect == true)) {
                        unEUREX.forEach(v=> {
                            v.cmajor = null
                        })
                    } else if ((item.productlink.indexOf('EUREX') >= 0 || item.productName.indexOf('香港') >= 0) && !EUREXOrHK.some(v=>v.cselect == true)) {
                        EUREXOrHK.forEach(v=>{
                            v.cmajor = null
                        })
                    }
                }
                this.tableData.forEach(v=>{//互斥罗辑，被排斥的项置灰
                    if (v._id != item._id && v.isMutex == item.isMutex && item.isMutex != 0) {
                        v.creject = !v.creject
                    }
                })
                call && call()
                this.$nextTick(() => {
                    this.$emit('change',this.totalPrice)
                })
            },
            selectItemByMemory (item) {//根据外部组件浅拷贝的缓存数据，选中当前组件中的项
                let target = this.tableData.find(v=>v.id == item.id)
                this.selectItem(target,resolve=>{
                    resolve(item.cmajor)
                })
            }, 
            choose (item, index) {
                this.$emit('choose',this.click,item,index)
            },
            clearData () {
                this.tableData = []
                this.internalData = []
                this.CMEData = []
                this.EUREXData = []
                this.ICEData = []
                this.otherOuterData = []
            },
            isDisable (item) {
                if (item.cdisable) {
                    return true
                } else if (item.creject) {
                    return true
                } else {
                    return false
                }
            },
            isEurexOrHK (item) {
                return item.productlink.indexOf('EUREX') >= 0 || item.productName.indexOf('香港') >= 0
                // return item.productlink.indexOf('EUREX') >= 0 
            },
            isEurex (item) {
                return item.productlink.indexOf('EUREX') >= 0
            },
            getSelect () {//用于向外暴露，AuthChoose中调用
                return this.tableData.filter(v=>v.cselect || v.isChecked)
            },
            checkRejection (id) {
                let checkItem = this.tableData.find(v=>v.id == id)
                let rejectItem
                for (let i = 0; i < this.tableData.length; i++) {
                    let item = this.tableData[i]
                    if (item.id != id && item.isMutex == checkItem.isMutex) {
                        rejectItem = item
                        break
                    }
                }
                rejectItem && (this.click(rejectItem))
                
                this.click(checkItem)
                return rejectItem && rejectItem.id
            },
            cancelAll () {
                //取消所有选中或者禁用的状态，暴露于外部使用
                this.tableData.forEach(v=>{
                    this.$set(v,'cselect',false)
                    this.$set(v,'creject',false)
                    this.$set(v,'cdisable',false)
                    this.$set(v,'cmajor',null)
                })
                this.$nextTick(() => {
                    this.$emit('change',this.totalPrice)
                })
            },
            setPriceByMode (x) {
                this.price_mode = x
                this.$nextTick(() => {
                    this.$emit('change',this.totalPrice)
                })
            },
            setPriceByItem (item) {
                let target = ([...this.internalData, ...this.currentData,...this.CMEData, ...this.EUREXData, ...this.ICEData, ...this.otherOuterData, ...this.HKData]).find(v => v.id == item.id)
                this.$set(target, 'quarterPrice', item.quarterPrice)
                this.$set(target, 'quartermajorprice', item.quartermajorprice)
                this.$nextTick(() => {
                    this.$emit('change',this.totalPrice)
                })
            },
            price (item) {
                switch (this.price_mode) {
                    case 'quater':
                        return parseInt(item.quarterPrice)
                    default:
                        return parseInt(item.price)
                }
            },
            majorPrice (item) {
                switch (this.price_mode) {
                    case 'quater':
                        return parseInt(item.quartermajorprice)
                    default:
                        return parseInt(item.majorprice)
                }
            }
        },
        computed: {
            totalPrice() {
                var price = 0;
                this.tableData.forEach((v, i) => {
                    if (v.cselect) {
                        if (v.cmajor == 0) {
                            price += parseFloat(this.price(v))
                        } else if (v.cmajor == 1) {
                            price += parseFloat(this.majorPrice(v))
                        } else {
                            price += parseFloat(this.price(v))
                        }
                    }
                })
                return price;
            },
            hasMajor () {
                return this.tableData.some(v=>v.cmajor)
            },
            hasOgz () {
                let flag = false
                this.tableData.forEach(v=>{
                    if (v.cmajor && (v.productlink.indexOf('EUREX') >= 0 || v.productName.indexOf('香港') >= 0)) {
                        flag = true
                    }
                })
                return flag
            },
            tabType () {
                return this.$store.state.globalTabType
            },
            isInternal () {
                return this.internalData.length > 0 || this.currentData.length > 0
            },
        },
        watch: {
            authData: {
                handler(val) {
                    this.clearData()//清空数据
                    if (val.length <= 0) return
                    this.tableData = val.map(v => {
                        var obj = {
                            ...v,
                            cmajor: null,
                            _id: wh.randomId()
                        }
                        if (obj.creject == undefined) {
                            obj.creject = false
                        } 
                        
                        if (obj.cdisable == undefined) {
                            obj.cdisable = false
                        }
                        if (obj.cselect == undefined) {
                            obj.cselect = false
                        }
                        return obj
                    })
                    this.internalData = this.tableData.filter(v=>v.isout == 0 && v.grouptype != 6)
                    this.currentData = this.tableData.filter(v=>v.isout == 0 && v.grouptype == 6)
                    this.CMEData = this.tableData.filter(v=>v.isout == 1 && v.grouptype == 1)
                    this.EUREXData = this.tableData.filter(v=>v.isout == 1 && v.grouptype == 2)
                    this.ICEData = this.tableData.filter(v=>v.isout == 1 && v.grouptype == 3)
                    this.HKData = this.tableData.filter(v=>v.isout == 1 && v.grouptype == 4 && v.productName.indexOf('香港') >= 0).reverse() //为了境内香港数据放到最后，手动调整了顺序
                    this.otherOuterData = this.tableData.filter(v=>v.isout == 1 && v.grouptype == 4 && v.productName.indexOf('香港') < 0)
                },
                immediate: true,
                deep: true
            },
            tabType: {
                handler(val){
                    if (this.globalTabType() == val && this.itemname == '境外实时数据' && this.fatherType() == this.globalTabType()) {//这里需要保持，全局的新购/加购/续费状态改变时，判断一下当前的数据表格是不是在对应栏目中，比如在加购栏中且全局选中的也是加购的时候，才把实例存住，香港授权在境外数据里面，所以也需要判断到
                        this.$store.commit('setTabInstance',this)
                    }
                },
                immediate:true
            }
        },
        mounted() {

        }
    }
</script>

<style scoped>
    .authorization-table {
        border-collapse: collapse;
        text-align: left;
        width: 100%;
        font-size: 12px;
        color: #525252;
        background: white;
    }
    .authorization-table tr {
        cursor: pointer;
    }
    .authorization-table tr.disabled {
        cursor: default;
    }
    .authorization-table td.data_box{
        border-bottom: 1px solid #ebf1f5;
        position: relative;
    }
    .authorization-table td.data_box.disabled {
        color: #b3b3b3;
    }
    .authorization-table td:nth-child(2) {
        text-align: left;
    }
    .authorization-table td i.tips{
        display: inline-block;
        width: 12px;
        height: 12px;
        /* background: url(../assets/image/zhuyi.png) no-repeat center; */
        position: relative;
        margin-left: 3px;
    }
    .authorization-table td i.tips .tips_content {
        display: none;
        position: absolute;
        top: 15px;
        left: -116px;
        font-style: normal;
        width: 200px;
        text-align: left;
        border: 1px dashed #aba1ce;
        background: #fffdec;
        z-index: 10;
        padding: 10px 1px 10px 10px;
        color: #525252;
        line-height: normal;
        font-weight: normal;
    }
    
    .authorization-table td i.tips .tips_content.EUREX {
        left: -196px;
    }
    .authorization-table td i.tips:hover .tips_content {
        display: block;
    }
    .authorization-table th {
        background: rgb(231, 235, 238);
        color: rgb(87, 91, 94);
        font-weight: normal;
        font-size: 14px;
        height: 24px;
        padding: 5px 2px;
        text-align: center;
        border: 1px solid rgb(211, 215, 218);
        border-bottom: 0;
        border-top: 0;
    }
    .authorization-table.yellow th {
        background: #ffebcc;
        color: rgb(87, 91, 94);
        font-weight: normal;
        font-size: 14px;
        height: 24px;
        padding: 5px 2px;
        text-align: center;
        border: 1px solid #f1cf9b;
        border-bottom: 0;
        border-top: 0;
    }
    .authorization-table.blue th {
        background: #bcdcf5;
        color: rgb(87, 91, 94);
        font-weight: normal;
        font-size: 14px;
        height: 24px;
        padding: 5px 2px;
        text-align: center;
        border: 1px solid #fff;
        border-bottom: 0;
        border-top: 0;
    }
    .authorization-table th.no_padding {
        padding: 0 2px;
    }
    .authorization-table h5,
    .authorization-list table p {
        margin: 0;
        padding: 0;
    }

    .authorization-table th h5 {
        font-size: 13px;
        font-weight: normal;
    }

    .authorization-table th p {
        font-size: 12px;
        font-weight: normal;
    }

    .authorization-table td {
        text-align: center;
        border: 0px solid #cccccc;
        border-right: 1px solid rgb(235, 241, 245);
        height: 24px;
        padding: 6px 2px;
        font-size: 14px;
    }
    .authorization-table tr td:last-child {
        border-right: 0;
    }
    .authorization-table tr td:first-child {
        border-right: 0;
    }
    .authorization-table td.purchaser {
        text-align: center;
        padding: 0 0;
    }
    .authorization-table td.charge {
        text-align: left;
        padding: 0 0;
        
    }
    .authorization-table td .price{
        padding-left: 38px;
    }
    .authorization-table .internal_tr td .price{
        padding-left: 0;
    }
    .authorization-table td .people,.authorization-table td .price {
        border-bottom: 1px solid rgb(235, 241, 245);
        display: block;
        line-height: 24px;
    }
    .authorization-table td .people:last-child,.authorization-table td .price:last-child {
        border-bottom: 0;
    }
    /* .authorization-table tr:hover {
        background-color: rgb(233, 241, 253);
    } */

    .authorization-table td .price.major_active {
        font-weight: 600;
        color: #78363A;
    }
    .authorization-table td.pop {
        color: #1261D2;
        position: relative;
    }

    .authorization-table td .pop_wraper {
        display: none;
        width: 427px !important;
        text-align: left !important;
        padding: 15px 17px 15px 20px;
        border: 1px dashed #aba1ce;
        background: #fffdec;
        position: absolute;
        left: -410px;
        z-index: 10;
        color: #525252;
        /* display: none; */
        top: 29px;
    }

    .authorization-table td.pop:hover .pop_wraper {
        display: block;
    }

    .authorization-table td .pop_wraper::before {
        content: '';
        position: absolute;
        right: 6px;
        top: -8px;
        border-bottom: 8px solid rgb(171, 161, 206);
        border-left: 8px solid transparent;
        border-right: 8px solid transparent;
    }

    .authorization-table td .select {
        width: 15px;
        height: 15px;
        display: inline-block;
        border: 1px solid rgb(175, 175, 175);
        box-sizing: border-box;
        border-radius: 100%;
        position: relative;
        top: 2px;
    }

    .authorization-table td .select.active {
        background: url(../../../assets/image/dui-bai.png) no-repeat center rgb(243, 152, 0);
        border: 1px solid rgb(243, 152, 0);
    }
    
    .authorization-table td .select.disabled {
        background: #e7ebee;
        border: 1px solid #d6d9dc;
    }
    .authorization-table td .select.active.disabled {
        background: url(../../../assets/image/dui-bai.png) no-repeat center #ced6dc;
        border: 1px solid rgb(175, 175, 175);
    }
    .authorization-table tr td.pop.last .pop_wraper{
        bottom: 35px;
        top: initial;
    }
    .authorization-table.few tbody tr:first-child td .pop_wraper{
        bottom: initial;
        top: 29px;
    }
    .authorization-table tr td.pop.last .pop_wraper::before {
        content: '';
        position: absolute;
        right: 6px;
        top: initial;
        bottom: -8px;
        border-bottom: 0;
        border-top: 8px solid rgb(171, 161, 206);
        border-left: 8px solid transparent;
        border-right: 8px solid transparent;
    }
    .authorization-table.few tbody tr:first-child td .pop_wraper::before{
        content: '';
        position: absolute;
        right: 6px;
        bottom: initial;
        top: -8px;
        border-bottom: 8px solid rgb(171, 161, 206);
        border-left: 8px solid transparent;
        border-right: 8px solid transparent;
        border-top: none;
    }
</style>